module.exports = __webpack_public_path__ + "static/2-c40faadcaea35dd6053d89657db0d5f4.jpeg";